export default function adLoaded(adName, status, store = {}) {
  return {
    type: 'AD_LOADED',
    adName,
    status,
    store
  };
}
